import React, {useEffect, useState} from "react";


export const Option = (props) => {
    let [optionValue, setOptionValue] = useState('');
    let [optionName, setOptionName] = useState('');
    let [isDisabled, setDisabled] = useState(false);
    useEffect(() => {
        if(props.elem === ''){
            setOptionValue('');
            setOptionName('הכל');
        } else if (props.elem.name){
            setOptionValue(props.elem.code);
            setOptionName(props.elem.name);
        } else {
            setOptionValue(props.elem);
            setOptionName(props.elem);
        }
    }, [props.value])
    return (
        <>
            <option value={optionValue} disabled={isDisabled} style={{color: `#000000`}}>{optionName}</option>
        </>
    )
}